import React from "react";
import { Input, InputDate } from "../../Helpers/Input/Input";
import { useSelector } from "react-redux";
import trans from "../../../utils";
import dayjs from "dayjs";
export default function UserPermissions({ addData }) {
	const inf = useSelector((state) => state.users.user);

	return (
		<div className="userinfo mb-24">
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("account limits")}
			</p>
			{/* <div className="flex-between">
				{(inf.administrator === true ||
					((inf?.adminstrator === false || inf?.deviceReadonly === false) &&
						(inf?.userLimit > 0 || inf?.userLimit === -1))) && (
					<>
						<UsersSwitch
							formstyle="form-input mb-2"
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							value={addData.values}
							addData={addData}
						/>
					</>
				)}
			</div> */}
			<div className="row">
				<div className="col-lg-6">
					<InputDate
						title={trans("Expiration Date")}
						id="expirationTime"
						name="expirationTime"
						onBlur={(value) => addData.setFieldTouched("expirationTime", true)}
						onChange={(value) => addData.setFieldValue("expirationTime", value)}
						errors={addData.errors.expirationTime}
						touched={addData.touched.expirationTime}
						value={addData.values.expirationTime || ""}
						maxDate={
							inf.expirationTime
								? dayjs(inf.expirationTime).endOf("day")
								: undefined
						}
					/>
				</div>
				{inf.administrator && (
					<div className="col-lg-6">
						<Input
							title={trans("Vehicle Limit")}
							type="number"
							formstyle="form-input"
							id="deviceLimit"
							name="deviceLimit"
							placeholder={trans("Ex. 5")}
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							errors={addData.errors.deviceLimit}
							touched={addData.touched.deviceLimit}
							value={addData.values.deviceLimit ?? ""}
							disabled={
								inf.administrator ||
								(!inf.deviceReadonly &&
									!inf.readonly &&
									(inf.deviceLimit === -1 ||
										inf.deviceLimit > 0 ||
										inf.userLimit === -1 ||
										inf.userLimit > 0))
									? false
									: true
							}
							min={0}
						/>
					</div>
				)}
				{inf.administrator && (
					<div className="col-lg-6">
						<Input
							title={trans("User Limit")}
							type="number"
							formstyle="form-input"
							id="userLimit"
							name="userLimit"
							placeholder={trans("Ex. 3")}
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							errors={addData.errors.userLimit}
							touched={addData.touched.userLimit}
							value={addData.values.userLimit ?? ""}
							disabled={
								inf.administrator ||
								(!inf.deviceReadonly &&
									!inf.readonly &&
									(inf.deviceLimit === -1 ||
										inf.deviceLimit > 0 ||
										inf.userLimit === -1 ||
										inf.userLimit > 0))
									? false
									: true
							}
							min={0}
						/>
					</div>
				)}
				{/**{inf.administrator && (
					<div className="col-lg-6">
						<InputParentGroup
							id="parent"
							name="parent"
							title={trans("User related to")}
							formstyle="form-input"
							onBlur={(value) => addData.setFieldTouched("parent", true)}
							onChange={(value) => addData.setFieldValue("parent", value)}
							errors={addData.errors.parent}
							touched={addData.touched.parent}
							value={addData.values.parent || ""}
						/>
					</div>
				)}**/}
			</div>
		</div>
	);
}
